import { createContext, useContext, useMemo } from 'react';

import { criarMascara, type Mascara } from './mascarar';

/**
 * O olhinho da tela, pra qualquer peça dela ler sem receber prop.
 *
 * O estado é um só para o app inteiro (ver useValoresOcultos); o provedor só
 * diz "esta tela é coberta". FORA das telas cobertas (Dashboard, Vendas,
 * Inadimplentes, Clientes, Comissões e Campanhas) não há provedor e o padrão
 * é "visível": os mesmos cards e formatadores são usados em outras telas
 * (Contatos usa a lista de Clientes, por exemplo), que ficam como sempre foram.
 */
export interface ContextoOlhinho {
  /** Há um provedor acima — a tela é coberta pelo olhinho. */
  ativo: boolean;
  oculto: boolean;
  carregando: boolean;
  alternar: () => void;
}

export const OlhinhoContext = createContext<ContextoOlhinho>({
  ativo: false,
  oculto: false,
  carregando: false,
  alternar: () => {},
});

export const useOlhinho = () => useContext(OlhinhoContext);

/** `m(formatCurrency(x))` → "R$ ••••" quando a tela está com os valores escondidos. */
export const useMascara = (): Mascara => {
  const { oculto } = useOlhinho();
  return useMemo(() => criarMascara(oculto), [oculto]);
};
